import type { BlockVolume, BlockVolumeStatus } from '@xver/apis/v1/block-storage/model';
import { useTranslation } from 'react-i18next';

const STATUS_STYLES: Record<BlockVolumeStatus, { color: string; backgroundColor: string }> = {
    creating: { color: 'var(--color-status-warning)', backgroundColor: 'rgba(251, 191, 36, 0.15)' },
    available: { color: 'var(--color-status-info)', backgroundColor: 'rgba(96, 165, 250, 0.15)' },
    attaching: {
        color: 'var(--color-status-warning)',
        backgroundColor: 'rgba(251, 191, 36, 0.15)',
    },
    attached: { color: 'var(--color-status-teal)', backgroundColor: 'rgba(45, 212, 191, 0.15)' },
    detaching: {
        color: 'var(--color-status-warning)',
        backgroundColor: 'rgba(251, 191, 36, 0.15)',
    },
    resizing: { color: 'var(--color-status-violet)', backgroundColor: 'rgba(167, 139, 250, 0.15)' },
    deleting: {
        color: 'var(--color-status-neutral)',
        backgroundColor: 'rgba(156, 163, 175, 0.15)',
    },
    error: { color: 'var(--color-status-danger)', backgroundColor: 'rgba(248, 113, 113, 0.15)' },
};

/** Status text badge, with the failure reason under it for `error`. */
export default function VolumeStatusBadge({
    volume,
}: {
    volume: Pick<BlockVolume, 'status'> & Partial<Pick<BlockVolume, 'statusReason'>>;
}) {
    const { t } = useTranslation('blockStorage');

    return (
        <div className="flex flex-col items-start gap-1">
            <span
                className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                style={STATUS_STYLES[volume.status]}
            >
                {t(`status.${volume.status}`)}
            </span>
            {volume.status === 'error' && volume.statusReason && (
                <span className="text-xs text-fg/68">{volume.statusReason}</span>
            )}
        </div>
    );
}
